import { z } from 'zod';

export const voucherLevelsResDto = z.object({
  current: z.number().describe('Current voucher level'),
  currentByType: z
    .object({
      TenEuros: z.number(),
      FiveEuros: z.number(),
    })
    .describe('Current voucher level per redeemable denomination'),
  lastWeek: z.number().describe('Vouchers redeemed in the last week'),
  lastMonth: z.number().describe('Vouchers redeemed in the last month'),
});
export type VoucherLevelsResDto = z.infer<typeof voucherLevelsResDto>;
